import { render } from "./PremiumUpgradeModal.vue?vue&type=template&id=001f33c4&scoped=true"
import script from "./PremiumUpgradeModal.vue?vue&type=script&lang=js"
export * from "./PremiumUpgradeModal.vue?vue&type=script&lang=js"

import "./PremiumUpgradeModal.vue?vue&type=style&index=0&id=001f33c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-001f33c4"]])

export default __exports__